import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface SalesDashboardBooking {
  id: string;
  code: string;
  bookingType: 'JOIN_TOUR' | 'GROUP_TOUR';
  customerName: string;
  tripName: string;
  totalAmount: number;
  status: string;
}

export interface SalesDashboard {
  period: { year: number; month: number };
  summary: {
    netSales: number;
    newBookingCount: number;
    outstandingAmount: number;
    outstandingBookingCount: number;
    pendingApprovalCount?: number;
  };
  recentBookings: SalesDashboardBooking[];
}

@Injectable({ providedIn: 'root' })
export class SalesDashboardService {
  private readonly http = inject(HttpClient);

  async getDashboard(): Promise<SalesDashboard> {
    const response = await firstValueFrom(
      this.http.get<{ dashboard: SalesDashboard }>(`${environment.apiUrl}/dashboard/sales`, {
        withCredentials: true,
      }),
    );
    return response.dashboard;
  }
}
